import React from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {GroupNameItem} from "utils/upsellsUtils";
import {ServerImage} from "components/ServerImage";
import ButtonSubmit from "pages/Front/Booking/components/ButtonSubmit";

const BookingUpsellCompetitionsGroupName = (props: {groupNameItem: GroupNameItem; isOpen: boolean; setIsOpen: (isOpen: boolean) => void}) => {
    const {t} = useTranslation();

    return (
        <div
            className={clsx("packageUpsellItemContainer overflow-hidden w-full flex flex-col bg-white rounded-xl shadow -mt-8")}
        >
            <div className={"w-full flex flex-col md:flex-row md:items-stretch"}>
                <div className={"flex flex-row w-full md:w-auto md:self-stretch md:flex-1"}>
                    <div
                        className={clsx(
                            "grow flex flex-col md:items-stretch w-full max-w-full",
                            "md:w-[16rem] md:max-w-[16rem] h-full"
                        )}
                    >
                        <div
                            className={clsx(
                                "itemImage flex h-full overflow-hidden w-full grow rounded-t-lg md:rounded-tr-none",
                                "md:max-h-full aspect-[64/56] sm:max-h-[250px] md:max-w-[16rem]"
                            )}
                        >
                            {props.groupNameItem.items[0].image && props.groupNameItem.items[0].image !== "" && (
                                <ServerImage
                                    alt={"Package Item Image"}
                                    className={"w-full md:max-h-auto object-cover object-center"}
                                    src={"/img/competitions/trophies.webp"}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div
                    className={clsx(
                        "flex flex-col items-start gap-x-4 w-full",
                        "justify-center px-4 lg:px-8 py-4 gap-y-2 md:gap-y-0"
                    )}
                >
                    <div className={"flex flex-row justify-center items-start gap-x-4 w-full"}>
                        <h3 className="text-black leading-tight text-base sm:text-xl lg:text-xl xl:text-2xl text-left font-bold flex-grow w-full">
                            {props.groupNameItem.groupName}
                        </h3>
                    </div>
                    <div className={"flex justify-center items-center h-full w-full text-black text-xs sm:text-sm lg:text-base font-medium"}>
                        <p className={"w-full"} dangerouslySetInnerHTML={{__html: t("More fun, <b>more action</b>: Now you can compete against each other in various competitions.")}} />
                    </div>
                </div>
                <div className={"md:border-l border-gray-300 flex flex-col items-center justify-center space-y-2 px-4 pt-0 pb-4 md:p-2"}>
                    <div className="items-center w-full justify-center flex flex-col md:flex-row md:space-x-4">
                        <div className={"w-full md:w-[180px] flex flex-row md:flex-col justify-between md:justify-center items-center"}>
                            <img src={"/img/competitions-tag-neu.svg"} className={"w-full h-full object-cover object-top max-w-[50px] md:max-w-[90px]"} />
                            <div className={"md:mt-4"}>
                                <ButtonSubmit
                                    buttonType={"arbo-orange"}
                                    className={clsx(
                                        "!w-auto md:grow rounded-lg !px-2 !py-1.5 md:!py-1 xl:!py-1.5 xl:!px-2 !text-lg xl:!text-xl !font-bold"
                                    )}
                                    icon={props.isOpen ? "up" : "down"}
                                    id={"ButtonSelectUpsell"}
                                    label={props.isOpen ? t("Hide") : t("Discover")}
                                    onClick={() => props.setIsOpen(!props.isOpen)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingUpsellCompetitionsGroupName;
